// extracted by mini-css-extract-plugin
export default {"card":"ContactPage_card__1-cGR","wrapper":"ContactPage_wrapper__ZRajr"};